<template>
  <div class="yunxiao teacher intention-clues">
    <div class="intention-infos infos-nave"  
      v-for="(infos, index) in list" 
      :key="index" 
      @click="toCluesDetailsPage(infos)" >
      <div class="title">
        <div class="left">
          <span style="padding-right:calc(var(--gap)*10);">
            {{infos.content || '-'}}
          </span>
        </div>
        <div class="right" >
          <span 
            class="status-tag" 
            :class="{
              red: infos.status === 3 || infos.status === 4,
              green: infos.status === 2
            }">
            {{statusDesc[infos.status]}}
          </span>
        </div>
      </div>
      <div class="line van-hairline--top" style="padding-top: calc(var(--gap)*12);">
        <div class="left">
          <van-rate
            v-model="infos.level"
            icon="like"
            void-icon="like-o"
            :size="12"
            color="var(--c-rate)"
            readonly
          />
        </div>
        <div class="right" style="color:var(--g7);">跟进人:{{infos.followTeacherName || '-'}}</div>
      </div>
    </div>
    <div 
      v-if="list.length && app.permission.op('add_intention_clue')" 
      class="add-clues-btns"  
      @click="$router.push('/addClue?studentId='+studentId)">
      <van-icon name="add" size="24" color="var(--c1)" style="margin-right: calc(var(--gap)*8);" />
      新增意向
    </div>
    <van-empty
      image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
      description="当前还没有意向记录"
      v-if="!list||(list&&list.length==0)"
      image-size="128">
      <van-button 
        square round 
        type="primary" 
        v-if="app.permission.op('add_intention_clue')"
        @click="$router.push('/addClue?studentId='+studentId)">
        添加学员意向
      </van-button>
    </van-empty>   
  </div>
</template>

<script>

export default {
  name: 'intention-clue',
  props: {
    list: {
      type: Array,
      default: function() {
        return [];
      }
    },
    studentId: {
      type: [Number, String],
    },
  },
  data () {
    return {      
      statusDesc: ['待确认','跟进中','已转化','已回收','转化失败'],
    }
  },
  methods: {
    toCluesDetailsPage (infos) {
      if (app.permission.op('all_intention_clue || my_intention_clue')) {
        this.$router.push(`/cluedetails?id=${infos.id}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.yunxiao.teacher.intention-clues{
  background-color: var(--g2);
  overflow: hidden;
  .infos-nave{
    margin: calc(var(--gap) * 16) calc(var(--gap) * 16) calc(var(--gap) * 12);
    padding: 0 calc(var(--gap) * 16) calc(var(--gap) * 16);
    border-radius: var(--radius-sm);
    background-color: var(--white);
    >.title{      
      font-size:var(--fs-lg);
      min-height: calc(var(--w) * 48);
      line-height:var(--lh-lg);
      font-weight: var(--bold);
    }
    >.title,
    >.line{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left{
        flex: 1;
      }
      .right{
        flex-shrink: 0;
        white-space: nowrap;

        .icon {
          width: 24px;
          height: 24px;
          &:last-child{
            margin-left: calc(var(--gap) * 24);
          }
        }
      }

      ::v-deep .van-rate>div{
        padding: 0;
        margin-right: calc(var(--gap) * 12);
      }
    }
  }
  .status-tag{
    padding: 0 calc(var(--gap) * 4);
    color: var(--c1);
    border-radius: calc(var(--radius-base) * 0.6);
    border: 1px solid var(--c1);
    font-size:var(--fs-sm);
    line-height:var(--lh-md);
    font-weight: normal;

    &.red{
      color: var(--c3);
      border-color: var(--c3);
    }
    &.green{
      color: var(--c2);
      border-color: var(--c2);
    }
  }
  .add-clues-btns{
    margin: calc(var(--gap) * 12) calc(var(--gap) * 16);
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(var(--w) * 72);
    font-size:var(--fs-md);
    line-height:var(--lh-md);
    color: var(--g8);
    font-weight: var(--bold);
    
    border-radius: var(--radius-sm);
    background-color: var(--white);
  }
}
</style>